export default function Repetition({ question, taskState }) {
  const idx = taskState?.idx || 0;
  
  return (
    <div className="flex flex-col items-center gap-8 w-full max-w-2xl">
      <div className="bg-secondary border-2 border-accent rounded-3xl p-12 shadow-2xl min-w-[300px] text-center">
        <p className="text-6xl md:text-7xl font-bold text-primary tracking-tight">
          {/* ИСПРАВЛЕНО: используем idx вместо wordIndex */}
          {typeof question.mediaText[idx] === 'string' 
            ? question.mediaText[idx] 
            : question.mediaText[idx]?.text}
        </p>
      </div>
      <div className="flex flex-wrap justify-center gap-2">
        {question.mediaText.map((word, i) => (
          <div key={i} className={`px-3 py-1 rounded-full text-xs font-medium transition-colors ${
            i < idx ? 'bg-green-500/20 text-green-600' :
            i === idx ? 'bg-accent text-white' :
            'bg-secondary text-muted-foreground'
          }`}>
            {/* ИСПРАВЛЕНО: проверяем, объект это или строка */}
            {typeof word === 'string' ? word : word.text}
          </div>
        ))}
      </div>
    </div>
  );
}